import Vue from "vue";
import Router from "vue-router";
import paths from "./paths";
import { isArray } from "util";

function loadView (view) {
  return (resovle) => import(`@/views/${view}.vue`).then(resovle);
}

function loadLayout (layout) {
  return (resovle) => import(`@/components/layouts/${layout}.vue`).then(resovle);
}

function route (path, view, layout, name, child, meta) {
  var childPath = []
  if (isArray(child)) {
    child.forEach(ele => {
      var data = route(ele.path, ele.view, ele.layout, ele.name, ele.child, ele.meta);
      childPath.unshift( data );
    });
  }

  return {
    name: name,
    path: path,
    component: layout ? loadLayout(layout) : loadView(view),
    meta: meta,
    children: childPath
  };
}

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: paths.map(path => route(path.path, path.view, path.layout, path.name, path.child, path.meta)).concat([
    { path: "*", redirect: "/404" }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  var isLogin = sessionStorage.getItem("asd-token") && sessionStorage.getItem("user");
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLogin) {
      next('/login');
    } else {
      next();
    }
  } else if (isLogin && to.name === "Login") {
    next('/dashboard');
  } else {
    next();
  }
});

export default router;
